import React from "react";
import Banner1 from '../assets/images/banner3.png'
import Banner2 from '../assets/images/banner9.png'
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Autoplay, Pagination } from "swiper/modules";
import 'swiper/css/pagination';

const SliderNew = () => {
  return (
    <div>
      <Swiper
       autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      // autoplay={false}
        modules={[EffectCoverflow, Autoplay,Pagination]} // Enable required modules
        // effect="coverflow" 
        // grabCursor={true} 
        // centeredSlides={true} 
        slidesPerView="auto" // Show as many slides as necessary to fill the screen
        loop={true} // Enable looping of slides
        spaceBetween={20} 
        // coverflowEffect={{
        //   rotate: 50, 
        //   stretch: 0, 
        //   depth: 600, 
        //   modifier: 1, 
        //   slideShadows: false,
        // }}
        pagination={{ clickable: true }}
        
        className="mySwiper newSwiper" >
        <SwiperSlide >
          <img src={Banner1} alt="" className='img-fluid' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Banner2} alt="" className='img-fluid' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Banner1} alt="" className='img-fluid' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Banner2} alt="" className='img-fluid' />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default SliderNew;
